/*
Based on Material Dashboard 2 React by Creative Tim (https://www.creative-tim.com)
Licensed under the MIT License (see LICENSE)

Original Copyright (c) 2013-2021 Creative Tim
Modifications (c) 2025 CodeWeave Solutions (Pty) Ltd
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme-dark/base/colors";
import typography from "assets/theme-dark/base/typography";

const { grey } = colors;
const { size } = typography;

const breadcrumbs = {
  styleOverrides: {
    li: {
      lineHeight: 0,
    },

    separator: {
      fontSize: size.sm,
      color: grey[600],
    },
  },
};

export default breadcrumbs;
